import { render, staticRenderFns } from "./buy-order-pane.vue?vue&type=template&id=4a5d0c16&scoped=true&"
import script from "./buy-order-pane.vue?vue&type=script&lang=ts&"
export * from "./buy-order-pane.vue?vue&type=script&lang=ts&"
import style0 from "./buy-order-pane.vue?vue&type=style&index=0&id=4a5d0c16&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a5d0c16",
  null
  
)

export default component.exports